export function sanitizeFilename(filename, maxLength = 100) {
  const lastDotIndex = filename.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0 && lastDotIndex < filename.length - 1;

  let name = hasExtension ? filename.slice(0, lastDotIndex) : filename;
  const extension = hasExtension ? filename.slice(lastDotIndex) : '';

  name = name.replace(/[^a-zA-Z0-9]/g, '_');

  const maxNameLength = maxLength - extension.length;
  if (name.length > maxNameLength) {
    name = name.slice(0, maxNameLength);
  }

  return name + extension;
}

export async function encodeFileToBase64(file, metadata = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(',')[1];

      resolve({
        file: base64,
        metadata: {
          filename: metadata.filename || file.name,
          'content_type': file.type,
          ...metadata,
        },
      });
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
